import { render, staticRenderFns } from "./ForwardRepresentative.vue?vue&type=template&id=120dd4d8"
import script from "./ForwardRepresentative.vue?vue&type=script&lang=js"
export * from "./ForwardRepresentative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports